import { IDataTableColumn } from "nsitools-react";
import * as React from "react";

import { KennelDogDto, KennelDogSearch, KennelDogApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";

export interface IKennelDogsPageProps {
  kennelId: number;
}

export const KennelDogsPage: React.FunctionComponent<IKennelDogsPageProps> = ({ kennelId }) => {
  const { t } = useTl();
  const api = useApiService(KennelDogApi);
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: KennelDogDto) => (
          <Link target="_blank" to={`${ERoutes.dog}/${row.dogId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroup",
        render: (row: KennelDogDto) => (
          <Link target="_blank" to={`${ERoutes.breedGroups}/${row.breedGroupId}/detail/view`}>
            {row.breedGroup}
          </Link>
        ),
      },

      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breed",
        render: (row: KennelDogDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>
            {row.breed}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Color),
        fieldName: "color",
        render: (row: KennelDogDto) => (
          <Link target="_blank" to={`${ERoutes.color}/${row.colorId}/detail/view`}>
            {row.color}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Identification1),
        computed: true,
        disableSorting: true,
        fieldName: "dogChip",
      },
      {
        header: () => t(ETLCodes.Pedigree),
        fieldName: "pedigree",
      },
    ],
    [t]
  );

  const search = React.useCallback(
    (sObj) => {
      return api.baseSearch(
        KennelDogSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, kennelId: kennelId })
      );
    },
    [api, currentLanguage.languageId, kennelId]
  );

  return (
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) => {
        return api.exportXlsFile(
          KennelDogSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, kennelId: kennelId })
        );
      }}
      sortKeys={{ name: "ASC" }}
      withCard={false}
    />
  );
};
